import React from "react";
import { Link } from "react-router-dom";
import { LogoHorizontal } from "./Logo";
import { SITE } from "../lib/site";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="relative bg-[#05070D] border-t border-[#D4AF37]/15 pt-20 pb-10"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 pb-16 border-b border-white/5">
          <div className="md:col-span-5">
            <LogoHorizontal />
            <p className="mt-6 text-[#A3ABB8] text-sm md:text-base font-light leading-relaxed max-w-md">
              ASHIR GROUP — Soluções financeiras estruturadas com segurança,
              tradição e inteligência estratégica.
            </p>
            <div className="mt-5 text-[11px] tracking-[0.14em] text-[#A3ABB8]" data-testid="footer-cnpj">
              CNPJ nº <span className="text-white">{SITE.cnpj}</span>
            </div>
          </div>

          <div className="md:col-span-3">
            <div className="overline mb-5">Navegação</div>
            <ul className="space-y-3 text-sm">
              {[
                ["Sobre", "#sobre"],
                ["Benefícios", "#beneficios"],
                ["Como Funciona", "#como-funciona"],
                ["Para Quem É", "#para-quem"],
                ["FAQ", "#faq"],
                ["Contato", "#contato"],
              ].map(([l, h]) => (
                <li key={h}>
                  <a
                    href={h}
                    data-testid={`footer-link-${h.slice(1)}`}
                    className="text-[#A3ABB8] hover:text-[#D4AF37] transition-colors font-light"
                  >
                    {l}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="overline mb-5">Matriz</div>
            <div className="text-[#A3ABB8] text-sm font-light leading-relaxed">
              {SITE.address.street}<br />
              {SITE.address.building}<br />
              {SITE.address.city} — {SITE.address.cep}
            </div>
            <div className="mt-6 space-y-1.5">
              <a
                href={`mailto:${SITE.email}`}
                data-testid="footer-email"
                className="block text-[#D4AF37] text-sm hover:text-[#F0CC59] transition-colors"
              >
                {SITE.email}
              </a>
              <div className="text-white text-sm font-light">{SITE.whatsappDisplay}</div>
            </div>
          </div>
        </div>

        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4 pt-8">
          <div className="text-xs text-[#A3ABB8] tracking-[0.1em] font-light">
            © {new Date().getFullYear()} ASHIR GROUP · CNPJ {SITE.cnpj} · Todos os direitos reservados.
          </div>
          <div className="flex items-center gap-6 text-xs text-[#A3ABB8] tracking-[0.1em]">
            <Link to="/privacidade" data-testid="footer-privacy" className="hover:text-[#D4AF37] transition-colors">
              Política de Privacidade
            </Link>
            <a href="#" data-testid="footer-terms" className="hover:text-[#D4AF37] transition-colors">
              Termos de Uso
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
